import { useAsync } from 'react-use';
import { CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingPerformanceDailyBreakdownV2 } from '@zg-rentals/ts-customer-analytics-client';

export const usePropertyDailyBreakdown = (listingAlias: string | null, startDate: string, endDate: string) => {
  return useAsync(async () => {
    if (!listingAlias) return null;

    return CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingPerformanceDailyBreakdownV2({
      listingAlias,
      startDayYyyyMmDd: startDate,
      endDayYyyyMmDd: endDate,
      includeMarketInsights: true,
      includeFreeStats: true,
    });
  }, [listingAlias, startDate, endDate]);
};
